import type { IDropdownItemNoClickableProps } from './DropdownItemNoClickable'

import { styled } from '@linaria/react'
import { DropdownItemColumnGap } from '../DropdownItem.h'

export const DropdownItemNoClickableSC = styled.div<IDropdownItemNoClickableProps>`
  display: flex;
  align-items: center;
  width: ${({ width }) => (width ? `${width}` : 'auto')};
  height: ${({ height }) => (height ? `${height}%` : 'auto')};
  padding: ${({ paddings }) =>
    paddings && paddings.length > 0
      ? paddings.map((item) => `var(${item})`)?.join(' ')
      : 0};
  column-gap: ${({ columnGap }) =>
    `var(${columnGap || DropdownItemColumnGap.INDENT_0})`};
  background-color: ${({ backgroundDefault }) => `var(${backgroundDefault})`};
  box-sizing: border-box;
  border: none;
`
